module.exports = __webpack_public_path__ + "static/media/DuplicateSlab-Regular-Italic.ed9b23f4.eot";